import React from "react";
import {
  Box,
  Typography,
  Grid,
  Card,
  CardContent,
  CardMedia,
  alpha,
} from "@mui/material";
import {
  EventAvailable as EventAvailableIcon,
  DesignServices as DesignServicesIcon,
  PeopleAlt as PeopleAltIcon,
  Restaurant as RestaurantIcon,
  MusicNote as MusicNoteIcon,
  PhotoCamera as PhotoCameraIcon,
} from "@mui/icons-material";

const Services = () => {
  const services = [
    {
      title: "Event Planning & Coordination",
      description:
        "End-to-end management of your event from concept to completion.",
      icon: <EventAvailableIcon sx={{ fontSize: 40 }} />,
      color: "#6a11cb",
    },
    {
      title: "Creative Design & Theming",
      description:
        "Custom themes, decor, and design elements tailored to your vision.",
      icon: <DesignServicesIcon sx={{ fontSize: 40 }} />,
      color: "#2575fc",
    },
    {
      title: "Vendor Management",
      description:
        "Coordination with caterers, venues, entertainers, and other suppliers.",
      icon: <PeopleAltIcon sx={{ fontSize: 40 }} />,
      color: "#ff5e62",
    },
    {
      title: "Catering & Hospitality",
      description: "Gourmet food and beverage services for any event size.",
      icon: <RestaurantIcon sx={{ fontSize: 40 }} />,
      color: "#00b09b",
    },
    {
      title: "Entertainment Booking",
      description:
        "Music, performers, speakers, and entertainment tailored to your event.",
      icon: <MusicNoteIcon sx={{ fontSize: 40 }} />,
      color: "#ff9966",
    },
    {
      title: "Photography & Videography",
      description: "Professional capture of your special moments.",
      icon: <PhotoCameraIcon sx={{ fontSize: 40 }} />,
      color: "#8e2de2",
    },
  ];

  return (
    <Box id="services" sx={{ py: 8 }}>
      <Typography
        variant="h2"
        align="center"
        sx={{
          mb: 2,
          background: "linear-gradient(135deg, #6a11cb 0%, #2575fc 100%)",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
          backgroundClip: "text",
          fontSize: { xs: "1.8rem", sm: "2.5rem", md: "3rem" }, // Smaller on mobile
        }}
      >
        Our Comprehensive Services
      </Typography>
      <Typography
        variant="h6"
        align="center"
        color="text.secondary"
        sx={{ mb: 6, maxWidth: 700, mx: "auto" }}
      >
        We provide end-to-end event management solutions to bring your vision to
        life
      </Typography>

      <Grid container spacing={4}>
        {services.map((service, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <Card
              sx={{
                height: "100%",
                display: "flex",
                flexDirection: "column",
                borderRadius: 3,
                overflow: "hidden"
              }}
            >
              <Box
                sx={{
                  height: 8,
                  width: "100%",
                  background: `linear-gradient(90deg, ${service.color} 0%, ${alpha(service.color, 0.7)} 100%)`,
                }}
              />
              <CardContent
                sx={{
                  p: 3,
                  flexGrow: 1,
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    width: 70,
                    height: 70,
                    borderRadius: "50%",
                    bgcolor: alpha(service.color, 0.1),
                    mb: 3,
                    color: service.color,
                  }}
                >
                  {service.icon}
                </Box>
                <Typography
                  variant="h5"
                  component="h3"
                  gutterBottom
                  sx={{ fontWeight: 600 }}
                >
                  {service.title}
                </Typography>
                <Typography
                  variant="body1"
                  color="text.secondary"
                  sx={{ flexGrow: 1 }}
                >
                  {service.description}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default Services;
